import { Button } from "@/components/ui";
import useWeighingFactor from "./useWeighingFactor";
import { Loader, Dialog, DataTable, FormInput, FormFileInput, Heading } from "@/components";
import { ArrowDownToLine, ArrowUpFromLine } from "lucide-react";
import { FormProvider } from "react-hook-form";
import { RULE_NAME, UPLOAD_FILE } from "./consts";
import { capitalize } from "@/lib/utils";

const WeighingFactor = ({activeType}: {activeType?: any}) => {
  const {
    onUploadTemplateClick,
    onUploadTemplate,
    openUploadDialog,
    fileInputRef,
    onDownloadTemplate,
    setOpenUploadDialog,
    isUploadTemplateLoading,
    isDownloadTemplateLoading,
    tableData,
    columns,
    form,
    requiredFields,
    isUpdatePending,
    isEdit,
    isLoadingRules,
    isRefetchRules,
    isConfig,
    breadcrumbData,
    currentType
  } = useWeighingFactor({activeType});
  const { errors } = form.formState;

  return (
    <div className={isConfig ? "p-4 md:p-6" : ""}>
      {isConfig ? <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title="Allocation Rule By Level - Weighing Factor"
            breadcrumbData={breadcrumbData}
          />
        </div>
        <div>
          <span className="text-[20px] font-semibold text-primary">{capitalize(currentType)}</span>
        </div>
      </div> : <></>}
      <div>
        <div className="bg-white rounded-t-lg flex flex-col md:flex-row md:items-start md:justify-between gap-3 p-5 pb-3">
          <div>
            <h3 className="text-[16px] font-semibold text-primary">
              Metric Value
            </h3>
            <p className="text-[12px] text-g-400 mt-1">
              Values used as allocation basis for receiver allocations.
            </p>
          </div>
          {isConfig ? <></> :
          <div className="flex flex-wrap items-center justify-end gap-2">
            <Button
              type="button"
              variant="ghost"
              className="h-auto p-0 text-[14px] text-primary hover:bg-transparent hover:text-primary"
              onClick={onDownloadTemplate}
              disabled={isDownloadTemplateLoading}
            >
              {isDownloadTemplateLoading ? <Loader variant="secondary" /> : <ArrowDownToLine className="h-3 w-3" />}
              Download Template
            </Button>
            <Button
              type="button"
              variant="ghost"
              className="h-auto p-0 text-[14px] text-primary hover:bg-transparent hover:text-primary"
              onClick={onUploadTemplateClick}
              disabled={isUploadTemplateLoading}
            >
              {isUploadTemplateLoading ? <Loader variant="secondary" /> : <ArrowUpFromLine className="h-3 w-3" />}
              Upload Template
            </Button>
          </div>}
        </div>

        {isLoadingRules || isRefetchRules ? <Loader /> : <DataTable
          data={tableData || []}
          columns={columns}
          className="border-0 shadow-none"
          hideFooter
        />}
      </div>

      <Dialog
        open={openUploadDialog} 
        setOpen={setOpenUploadDialog} 
        title="Upload Template"
        saveText="Upload"
        isLoading={isUploadTemplateLoading || isUpdatePending} 
        onSave={form.handleSubmit(onUploadTemplate)}
      >
        <FormProvider {...form}>
          <form>
            <div className="grid grid-cols-1 gap-[20px]">
              <FormInput 
                name={RULE_NAME}
                control={form.control}
                label="Rule Name"
                placeholder="Please enter"
                error={(errors as any)[RULE_NAME]?.message}
                isRequired={requiredFields?.includes(RULE_NAME)}
                disabled={isEdit}
              />
              <FormFileInput
                fileInputRef={fileInputRef} 
                name={UPLOAD_FILE}
                control={form.control}
                label={<span>Upload File<span className="text-[10px]">(Max limit 10,000)</span></span>}
                placeholder="Please enter"
                error={(errors as any)[UPLOAD_FILE]?.message}
                isRequired={requiredFields?.includes(UPLOAD_FILE)}
                accept=".xlsx, .excel"
              />
            </div>
          </form>
        </FormProvider>
      </Dialog>
    </div>
  )
}

export default WeighingFactor;